/**
 * LegalInformation component
 * @returns <LegalInformation />
 */

const LegalInformation = ({ doc, texts, id }) => {

    const matchingDoc = doc?.find(item => item.id === id);
    
    return (
        <div className="legal-info">
            <div className="wrapper">

            {
                matchingDoc?.documents ?
                <div className="legal-info-doc">
                    <h5 className="title">Mantén tu lexus en perfecto estado</h5>
                    <a className="text-link primary-link-black with-icon" href={matchingDoc?.documents} download>
                        Descargar manual de garantía
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_4906_227)">
                            <path d="M12.6667 6H10V2H6.00004V6H3.33337L8.00004 10.6667L12.6667 6ZM7.33337 7.33333V3.33333H8.66671V7.33333H9.44671L8.00004 8.78L6.55337 7.33333H7.33337ZM3.33337 12H12.6667V13.3333H3.33337V12Z" fill="black"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_4906_227">
                            <rect width="16" height="16" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </a>
                </div>
                : null
            }

                <p>{texts}</p>
            </div>
        </div>
    )
}

export default LegalInformation
